/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateRelationshipMutationVariables = Types.Exact<{
  firmId: Types.Scalars['UUID']['input'];
  underwriterEmployeeId: Types.Scalars['UUID']['input'];
  input: Types.InvestorRelationshipUpdateDtoInput;
}>;

export type UpdateRelationshipMutation = {
  readonly __typename?: 'Mutation';
  readonly updateInvestorRelationship?: {
    readonly __typename?: 'UpdateInvestorRelationshipPayload';
    readonly investorFirmRelationship?: {
      readonly __typename?: 'InvestorFirmRelationship';
      readonly relationshipStatus: Types.RolodexRecordStatus;
      readonly relationshipType: Types.RelationshipType;
    } | null;
  } | null;
};

export type AdminUpdateRelationshipMutationVariables = Types.Exact<{
  input: Types.AdminUpdateInvestorRelationshipInput;
}>;

export type AdminUpdateRelationshipMutation = {
  readonly __typename?: 'Mutation';
  readonly adminUpdateInvestorRelationship?: {
    readonly __typename?: 'AdminUpdateInvestorRelationshipPayload';
    readonly investorFirmRelationship?: {
      readonly __typename?: 'InvestorFirmRelationship';
      readonly relationshipStatus: Types.RolodexRecordStatus;
      readonly relationshipType: Types.RelationshipType;
    } | null;
  } | null;
};

export type InvestorFirmRelationshipFieldsFragment = {
  readonly __typename?: 'InvestorFirmRelationship';
  readonly relationshipStatus: Types.RolodexRecordStatus;
  readonly relationshipType: Types.RelationshipType;
};

export const InvestorFirmRelationshipFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmRelationshipFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const UpdateRelationshipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRelationship' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'underwriterEmployeeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'InvestorRelationshipUpdateDtoInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateInvestorRelationship' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'firmId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'underwriterEmployeeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'underwriterEmployeeId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'input' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmRelationship' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorFirmRelationshipFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmRelationshipFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateRelationshipMutationFn = Apollo.MutationFunction<
  UpdateRelationshipMutation,
  UpdateRelationshipMutationVariables
>;

/**
 * __useUpdateRelationshipMutation__
 *
 * To run a mutation, you first call `useUpdateRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRelationshipMutation, { data, loading, error }] = useUpdateRelationshipMutation({
 *   variables: {
 *      firmId: // value for 'firmId'
 *      underwriterEmployeeId: // value for 'underwriterEmployeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRelationshipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRelationshipMutation,
    UpdateRelationshipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateRelationshipMutation, UpdateRelationshipMutationVariables>(
    UpdateRelationshipDocument,
    options
  );
}
export type UpdateRelationshipMutationHookResult = ReturnType<typeof useUpdateRelationshipMutation>;
export type UpdateRelationshipMutationResult = Apollo.MutationResult<UpdateRelationshipMutation>;
export type UpdateRelationshipMutationOptions = Apollo.BaseMutationOptions<
  UpdateRelationshipMutation,
  UpdateRelationshipMutationVariables
>;
export const AdminUpdateRelationshipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AdminUpdateRelationship' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AdminUpdateInvestorRelationshipInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminUpdateInvestorRelationship' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmRelationship' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorFirmRelationshipFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmRelationshipFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AdminUpdateRelationshipMutationFn = Apollo.MutationFunction<
  AdminUpdateRelationshipMutation,
  AdminUpdateRelationshipMutationVariables
>;

/**
 * __useAdminUpdateRelationshipMutation__
 *
 * To run a mutation, you first call `useAdminUpdateRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateRelationshipMutation, { data, loading, error }] = useAdminUpdateRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateRelationshipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminUpdateRelationshipMutation,
    AdminUpdateRelationshipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminUpdateRelationshipMutation,
    AdminUpdateRelationshipMutationVariables
  >(AdminUpdateRelationshipDocument, options);
}
export type AdminUpdateRelationshipMutationHookResult = ReturnType<
  typeof useAdminUpdateRelationshipMutation
>;
export type AdminUpdateRelationshipMutationResult =
  Apollo.MutationResult<AdminUpdateRelationshipMutation>;
export type AdminUpdateRelationshipMutationOptions = Apollo.BaseMutationOptions<
  AdminUpdateRelationshipMutation,
  AdminUpdateRelationshipMutationVariables
>;
